import { confirmationsStore } from '@/models/stores/confirmations';
import { ConfirmationField, ConfirmationTargetType } from '@/models/types';

const OPTIONAL_CONFIRMATION_FIELDS = new Set<ConfirmationField>([
  ConfirmationField.TradeInYMM,
]);

const REQUIRED_CONFIRMATION_FIELDS: ConfirmationField[] = [
  ConfirmationField.CustomerName,
  ConfirmationField.CustomerEmail,
  ConfirmationField.CustomerPhoneNumber,
  ConfirmationField.CustomerRegistrationAddress,

  ConfirmationField.Vin,
  ConfirmationField.Odometer,
  ConfirmationField.RapidReconStatus,
  ConfirmationField.VehicleCurrentLocation,
  ConfirmationField.DeliveryStage,
];

export function getMissingDealConfirmations({
  dealId,
  hasCoRegistrant = false,
  hasDeliveryAddress = false,
}: {
  dealId: string;
  hasCoRegistrant?: boolean;
  hasDeliveryAddress?: boolean;
}) {
  const fields: ConfirmationField[] = [...REQUIRED_CONFIRMATION_FIELDS];

  if (hasCoRegistrant) {
    fields.push(
      ConfirmationField.CoRegistrantName,
      ConfirmationField.CoRegistrantEmail,
      ConfirmationField.CoRegistrantPhoneNumber,
      ConfirmationField.CoRegistrantRegistrationAddress,
    );
  }

  if (hasDeliveryAddress) {
    fields.push(ConfirmationField.CustomerDeliveryAddress);
  }

  return fields
    .filter((field) => !OPTIONAL_CONFIRMATION_FIELDS.has(field))
    .filter((field) => {
      const confirmation = confirmationsStore.getByTargetAndField(
        dealId,
        ConfirmationTargetType.Deal,
        field,
      );
      return !confirmation?.confirmed;
    });
}
